import { Notification } from '@hs/hanshow-ui';
let notifyInstance = null;
const resNotification = options => {
    if (notifyInstance) {
        notifyInstance.close();
    }
    notifyInstance = Notification(options);
};

['error', 'success', 'info', 'warning'].forEach(type => {
    resNotification[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options,
                duration: 2000
            };

        }
        options.type = type;
        return resNotification(options);
    };
});

export default resNotification;